import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

/**
 * Used together with @see HttpStabilityInterceptor
 */
@Injectable({
    providedIn: 'root'
})
export class HttpStabilityService {
    private _isStable: Subject<void> = new Subject();

    public markAsStable() {
        this._isStable.next();
    }

    public whenStable(): Observable<void> {
        return this._isStable.asObservable();
    }
}
